import config from 'config';
import store from '../store';
import Utils from '../utils/utils';
import * as types from '../actions/login-actions';
import * as errorTypes from '../actions/error-actions';

import dbInstance from './dbInstace';

class LoginApi {

	/**
	 * Gets Headers and verify if exists msisdn enrichment
	 */
	static checkMsisdnInHeader() {
		return dbInstance.get(config.core.API.routes.headers.requestHeaders).then(response => {
			console.debug(response);

			let msisdn = Utils.getMsisdnInHeader(response);

			if (!msisdn) throw null;

			store.dispatch({
				type: types.MSISDN_IN_HEADER,
				msisdn: msisdn
			});
			return msisdn;
		}).catch(error => {
			console.info(error);
			return error;
		});
	}

	/**
	 * Sets the activations steps to control LoginForm Component views
	 */
	static activationStep(step) {
		store.dispatch({
			type: types.ACTIVATION_STEP,
			step: step
		});
	}

	/**
	 * Request SMS to validate login
	 */
	static requestSMS(msisdn, nextStep, resendCode) {

		if (!msisdn) {
			store.dispatch({
				type: errorTypes.GET_USER_ERROR,
				error: "missingMsisdn"
			});

			return Promise.reject("missingMsisdn");
		}

		let params = {params: {msisdn: Utils.insertMsisdnPrefix(msisdn)}};

		return dbInstance.get(config.core.API.routes.user.getUser, params).then(() => {
			return dbInstance.get(config.core.API.routes.login.requestSMS, params).then(response => {
				console.debug(response);
				store.dispatch({
					type: types.ACTIVATION_STEP,
					step: nextStep,
					resendCode: resendCode
				});

				store.dispatch({
					type: errorTypes.INVALID_VALIDATION_CODE,
					error: false
				});
				store.dispatch({
					type: errorTypes.SUBSCRIBE_NO_CREDITS,
					error: false
				});
				store.dispatch({
					type: errorTypes.SUBSCRIBE_GENERAL_ERROR,
					error: false
				});				

				return response;
			}).catch(err => {
				console.info(err);
				store.dispatch({
					type: errorTypes.REQUEST_SMS_ERROR,
					error: "requestSmsError"
				});
				return err;
			});
		}).catch(err => {
			console.info(err);

			Utils.gaSend('Assinatura', 'Solicitação do código de validação', 'Erro');
			store.dispatch({
				type: errorTypes.GET_USER_ERROR,
				error: "getUserError"
			});
			return err;
		});
	}

	/**
	 * Checks validate code
	 */
	static validateCode(msisdn, validateCode, step) {
		let params = {params: {
			msisdn: Utils.insertMsisdnPrefix(msisdn),
			validateCode
		}};

		return dbInstance.get(config.core.API.routes.login.validateCode, params).then(response => {
			console.debug(response.valid);

			if (!response.valid) {
				Utils.gaSend('Assinatura', 'Código de Validação', 'Código Inválido');
				throw 'Invalid validation code';
			}

			return response.valid
		}).catch(err => {
			console.info(err);

			Utils.gaSend('Assinatura', 'Código de Validação', 'Erro na solicitação do código');
			store.dispatch({
				type: errorTypes.INVALID_VALIDATION_CODE,
				error: err
			});

			store.dispatch({
				type: types.ACTIVATION_STEP,
				step: step,
				resendCode: false
			});
			return null;
		});

	}
}

export default LoginApi;


// WEBPACK FOOTER //
// ./src/api/login-api.js